"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVariablePriceUi = function IconVariablePriceUi(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M4 2H2v20h20v-2H4v-5.72q.195 0 .407-.012c.779-.047 2.046-.266 2.766-1.299.37-.529.638-.733.781-.805.098-.049.13-.037.153-.028h.004c.065.024.18.096.339.266.154.167.292.36.436.567.167.241.426.567.765.839.333.267.837.555 1.467.535.662-.02 1.232-.369 1.69-.91.447-.527.84-1.288 1.195-2.309.245-.702.5-.981.634-1.075.082-.058.129-.062.223-.026.141.056.366.218.6.555.228.326.423.758.537 1.245C16.5 13.99 17.892 15 19.206 15H22v-2h-2.794c-.176 0-.917-.15-1.261-1.63a5.7 5.7 0 0 0-.844-1.936c-.376-.54-.886-1.028-1.512-1.273a2.18 2.18 0 0 0-2.1.25c-.617.432-1.06 1.154-1.374 2.055-.318.909-.61 1.412-.832 1.674-.118.14-.195.187-.228.202a.5.5 0 0 1-.153-.094 2 2 0 0 1-.376-.423l-.01-.014a7 7 0 0 0-.602-.77c-.26-.28-.634-.61-1.128-.787-.536-.192-1.134-.176-1.729.123-.556.279-1.055.776-1.524 1.448-.157.224-.566.406-1.244.446A5 5 0 0 1 4 12.28zm7.036 10.348q0 0 .01-.003-.01.001-.01.003",
    clipRule: "evenodd"
  })));
};

export { IconVariablePriceUi, IconVariablePriceUi as default };
